import { render, staticRenderFns } from "./ProductAttributeIconsOverlay.vue?vue&type=template&id=898e51d0&scoped=true&"
import script from "./ProductAttributeIconsOverlay.vue?vue&type=script&lang=js&"
export * from "./ProductAttributeIconsOverlay.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributeIconsOverlay.vue?vue&type=style&index=0&id=898e51d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898e51d0",
  null
  
)

export default component.exports